// extracted by mini-css-extract-plugin
export default {"box":"Connect_box__XHHSC","icon":"Connect_icon__kdUNT","link":"Connect_link__BxFW4"};